import { useMutation } from 'react-query'
import { companyUseCase } from '../../factories'

const useUpdateCompany = () => useMutation(companyUseCase.updateCompany)

export default useUpdateCompany
